import { memo } from 'react';
import SectionTitle from '../../../../../components/sharedcomponents/SectionTitle';
import BarRow from '../../../../../components/sharedcomponents/BarRow';
import AnimatedCounter from '../../../../../components/sharedcomponents/Animations/AnimatedCounter';

interface TrafficSource {
  source: string;
  medium: string;
  sessions: string;
}

interface TrafficTabProps {
  data: TrafficSource[];
}

const TrafficTab = memo(({ data }: TrafficTabProps) => {
  const sources = data.slice(0, 10);
  const maxSessions = sources.length ? parseInt(sources[0]?.sessions) || 1 : 1;

  return (
    <div>
      <SectionTitle>Sources de Trafic</SectionTitle>
      <div className="bg-white rounded-2xl border border-blue-100 shadow-sm p-5">
        {sources.map((s, i) => (
          <BarRow
            key={i}
            label={s.source}
            sublabel={s.medium}
            percentage={(parseInt(s?.sessions || '0') / maxSessions) * 100}
            value={
              <AnimatedCounter
                end={parseInt(s?.sessions || '0')}
                suffix=" sess."
                duration={1200 + i * 100}
              />
            }
          />
        ))}
      </div>
    </div>
  );
});

TrafficTab.displayName = 'TrafficTab';

export default TrafficTab;